// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 房间页面样式 */

.room-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, var(--lemon-50), var(--mango-50), var(--leaf-50));
}

.connecting-overlay {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.connecting-content {
  text-align: center;
  background: var(--crystal-bg);
  backdrop-filter: var(--crystal-backdrop);
  border: 1px solid var(--crystal-border);
  border-radius: 16px;
  padding: 3rem 2rem;
  box-shadow: var(--crystal-shadow);
}

.connecting-content .loading-spinner {
  width: 60px;
  height: 60px;
  border: 3px solid var(--gray-200);
  border-top: 3px solid var(--lemon-500);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 2rem;
}

.connecting-content h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--gray-800);
  margin-bottom: 0.5rem;
}

.connecting-content p {
  color: var(--gray-600);
  margin-bottom: 2rem;
}

.loading-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
}

.loading-container .loading-spinner {
  font-size: 3rem;
  color: #ffa500;
  margin-bottom: 1rem;
  animation: spin 1s linear infinite;
}

.loading-container p {
  color: rgba(0, 0, 0, 0.7);
  font-size: 1.2rem;
  margin: 0;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.room-main {
  flex: 1;
  display: grid;
  grid-template-columns: 350px 1fr;
  gap: 2rem;
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  height: calc(100vh - 80px); /* 减去Header高度 */
  overflow: hidden;
}


@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .room-main {
    grid-template-columns: 1fr;
    padding: 1rem;
    height: auto;
    overflow: visible;
  }
}


@media (max-width: 768px) {
  .room-main {
    gap: 1rem;
  }
  
  .connecting-content {
    padding: 2rem 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/RoomPage.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,qFAAqF;AACvF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,wCAAwC;EACxC,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,sCAAsC;EACtC,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,0BAA0B,EAAE,eAAe;EAC3C,gBAAgB;AAClB;;;AAGA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,UAAU;AACV;EACE;IACE,0BAA0B;IAC1B,aAAa;IACb,YAAY;IACZ,iBAAiB;EACnB;AACF;;;AAGA;EACE;IACE,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* 房间页面样式 */\n\n.room-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(135deg, var(--lemon-50), var(--mango-50), var(--leaf-50));\n}\n\n.connecting-overlay {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\n.connecting-content {\n  text-align: center;\n  background: var(--crystal-bg);\n  backdrop-filter: var(--crystal-backdrop);\n  border: 1px solid var(--crystal-border);\n  border-radius: 16px;\n  padding: 3rem 2rem;\n  box-shadow: var(--crystal-shadow);\n}\n\n.connecting-content .loading-spinner {\n  width: 60px;\n  height: 60px;\n  border: 3px solid var(--gray-200);\n  border-top: 3px solid var(--lemon-500);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 2rem;\n}\n\n.connecting-content h2 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--gray-800);\n  margin-bottom: 0.5rem;\n}\n\n.connecting-content p {\n  color: var(--gray-600);\n  margin-bottom: 2rem;\n}\n\n.loading-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  text-align: center;\n}\n\n.loading-container .loading-spinner {\n  font-size: 3rem;\n  color: #ffa500;\n  margin-bottom: 1rem;\n  animation: spin 1s linear infinite;\n}\n\n.loading-container p {\n  color: rgba(0, 0, 0, 0.7);\n  font-size: 1.2rem;\n  margin: 0;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.room-main {\n  flex: 1;\n  display: grid;\n  grid-template-columns: 350px 1fr;\n  gap: 2rem;\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n  width: 100%;\n  height: calc(100vh - 80px); /* 减去Header高度 */\n  overflow: hidden;\n}\n\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* 响应式设计 */\n@media (max-width: 1024px) {\n  .room-main {\n    grid-template-columns: 1fr;\n    padding: 1rem;\n    height: auto;\n    overflow: visible;\n  }\n}\n\n\n@media (max-width: 768px) {\n  .room-main {\n    gap: 1rem;\n  }\n  \n  .connecting-content {\n    padding: 2rem 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
